
import { defineComponent, watch } from "vue";
import Payment from "@/components/Payment/index.vue";
import CusModal from "@component/CusModal/index.vue";
import { storeToRefs } from "pinia";
import { useGameListStore } from "@/store/gameList";
import { useloginStore } from "@/store/login";
import { useLayoutDataStore } from "@/store/layoutData";

export default defineComponent({
  components: {
    Payment,
    CusModal,
  },
  name: "BuyGoodModal",
  setup() {
    const gameListStore = useGameListStore();
    const loginStore = useloginStore();
    const layoutDataStore = useLayoutDataStore();
    const {
      isShowBuyGoodModal,
      buyGoodModalGoodsKind,
      buyGoodModalGoodsId,
      buyGoodModalGameId,
    } = storeToRefs(gameListStore);

    const hideBuyGoodsModal = () => {
      gameListStore.update_isShowBuyGoodModal(false);
      console.log("hideBuyGoodsModal");
    };

    // 当宝余额不足时，打开充值弹窗, 同时关闭自己
    // 因为当打开了购买弹窗 又打开了 充值弹窗，由于公用了一个推送码800006,且购买商品弹窗都做了监听，为了防止状态混乱，这里需要关闭购买商品弹窗
    const gotoRechargeWhenNotEnough = () => {
      gameListStore.update_isShowBuyGoodModal(false);
      loginStore.update_isShowRecharge(true, 1);
    };
    // // 查看是否购买成功，并获取游戏账号类型
    // const checkIsDeliveryCompleted = async () => {
    //   const buyGoodsInfo = localCache.getItem("buyGoodsInfo", 1);
    //   console.log(buyGoodsInfo, "buyGoodsInfo");
    //   if (buyGoodsInfo) {
    //     try {
    //       const res = await apiIsDeliveryCompleted({
    //         gameId: buyGoodsInfo.gameId,
    //         orderId: buyGoodsInfo.orderId,
    //         mallGoodsId: buyGoodsInfo.goodsId,
    //       });
    //       if (res.isCompleted) {
    //         layoutDataStore.updateStateProp("goodsGameType", res.jumpType);
    //         await loginStore.getPurchasedGameList(res.id);
    //         layoutDataStore.updateStateProp("showPurchaseCompleted", true);
    //       } else {
    //         message.error("IsDeliveryCompleted:false");
    //       }
    //       console.log(res, "checkIsDeliveryCompleted");
    //     } catch (error) {
    //       console.log(error, "checkIsDeliveryCompleted");
    //     }
    //   }
    // };

    // 每次打开购买商品窗口时，将支付成功的状态重置
    watch(
      () => gameListStore.isShowBuyGoodModal,
      () => {
        if (gameListStore.isShowBuyGoodModal) {
          loginStore.update_isUserPaySuccess(false);
        }
      }
    );

    // // 购买成功后把弹窗关闭
    // watch(
    //   () => loginStore.isUserPaySuccess,
    //   () => {
    //     if (loginStore.isUserPaySuccess) {
    //       gameListStore.update_isShowBuyGoodModal(false);
    //       checkIsDeliveryCompleted();
    //     }
    //   }
    // );

    return {
      hideBuyGoodsModal,
      buyGoodModalGoodsKind,
      buyGoodModalGoodsId,
      isShowBuyGoodModal,
      gotoRechargeWhenNotEnough,
      buyGoodModalGameId,
    };
  },
});
